<template>
  <div class="welcome-page">
    <nav class="navbar">
      <div class="navbar-left">
        <img src="/avevpn-logo.svg" alt="AVE VPN" class="logo" />
      </div>
      <div
        class="burger"
        :class="{ open: isMenuOpen }"
        @click="toggleMenu"
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
      <!-- Меню -->
      <ul
        class="navbar-menu"
        :class="{ open: isMenuOpen }"
      >
        <li><a href="#advantages" @click="closeMenu">Тарифы</a></li>
        <li><a href="#tariffs" @click="closeMenu">Пратнёрам</a></li>
        <li><a href="#contacts" @click="closeMenu">Контакты</a></li>
        <li><a href="https://avevpn.org/blog/">Блог</a></li>
      </ul>
      <div class="navbar-right">
        <a class="cabinet-link" @click="goToTelegram">Подключить</a>
      </div>
    </nav>

    <div class="content">
      <h1>AVE<span class="highlight" >VPN</span></h1>
      <div class="content-info">
        <p class="left-info">Самый быстрый и стабильный VPN для повседневного использования</p>
        <div class="test-info">
          <p>Протестируй бесплатно 9 дней по промокоду <span class="highlight" >FREE7</span></p>
          <button @click="goToTelegram" >Попробовать</button>
        </div>
      </div>

    </div>

    <!-- Разделы лендинга -->
    <section id="advantages" class="section">
      <h1 style="margin: 40px 0 60px;">AVE VPN - это самые выгодные условия на рынке</h1>
      <div class="free-trial-info">
        <p>Попробуйте AVE VPN</p>
        <div class="free-trial">
          <p>БЕСПЛАТНО</p>
          <div class="badge">
            <p>216 часов</p>
          </div>
        </div>
        <button @click="goToTelegram" >Попробовать</button>
      </div>
      <div class="or">
        <span>или</span>
      </div>

      <div class="tariffs-wrapper">
        <div class="basic">
          <div class="tariff-icon">
            <img src="https://avevpn.com/1.bYrXEiU8.webp" alt="">
            <div class="overlay-text">
              <span>Basic 🧵</span>
            </div>
          </div>
          <div class="tariff-info">
            <h2>1 устройство</h2>
            <p>Полный безлимит на месяц</p>
            <p>Скорость до 20ГБ/С</p>
            <p>Премиум-поддержка</p>
          </div>
          <div class="tariff-price">
            <div class="prices">
              <span class="old-price">179₽</span>
              <h2 class="new-price">99₽</h2>
            </div>
            <button @click="goToTelegram" >Купить</button>
          </div>
        </div>

        <div class="medium">
          <div class="tariff-icon">
            <img src="https://avevpn.com/2.B_tLAZ0a.webp" alt="">
            <div class="overlay-text">
              <span>Medium 🚀</span>
            </div>
          </div>
          <div class="tariff-info">
            <h2>2 устройства</h2>
            <p>Полный безлимит на месяц</p>
            <p>Скорость до 20ГБ/С</p>
            <p>Премиум-поддержка</p>
          </div>
          <div class="tariff-price">
            <div class="prices">
              <span class="old-price">299₽</span>
              <h2 class="new-price">179₽</h2>
            </div>
            <button @click="goToTelegram" >Купить</button>
          </div>
        </div>

        <div class="premium">
          <div class="tariff-icon">
            <img src="https://avevpn.com/3.B0PnIC3w.webp" alt="">
            <div class="overlay-text">
              <span>Premium 💎</span>
            </div>
          </div>
          <div class="tariff-info">
            <h2>5 устройств</h2>
            <p>Полный безлимит на месяц</p>
            <p>Скорость до 20ГБ/С</p>
            <p>Премиум-поддержка</p>
          </div>
          <div class="tariff-price">
            <div class="prices">
              <span class="old-price">499₽</span>
              <h2 class="new-price">349₽</h2>
            </div>
            <button @click="goToTelegram" >Купить</button>
          </div>
        </div>

      </div>
    </section>

    <section id="tariffs" class="section">
      <h1 style="margin: 40px 0 60px;">Самые выгодные условия для наших партнеров</h1>

      <div class="partners-wrapper">

        <div class="cabinet-info-wrapper">
        <div class="cabinet-info">
          <img src="iphone.png" alt="">
          <div class="cabinet-info-text">
            <h2>Понятный интерфейс и быстрый вывод</h2>
            <p>Личный кабинет партнера прямо в приложении</p>
            <p>Вывод USDT в любую удобную сеть, в любое время</p>
            <p>Всё честно и прозрачно</p>
          </div>
        </div>
      </div>

        <div class="conditions-wrapper">
          <div class="program-wrapper">
            <h2>RevShare</h2>
            <p>Пассивный стабильный доход</p>
          </div>
          <div class="program-info">
            Вы получаете 100% с первой оплаты вашего реферала, 60% с каждого его продления
            <button @click="goToTelegram" >Узнать больше</button>
          </div>
        </div>

        <div class="conditions-wrapper">
          <div class="program-info">
            Лично обсуждаем условия с каждым новым партнером, чтобы подобрать наилучшие именно для вас
            <button @click="goToTelegram" >Узнать больше</button>
          </div>
          <div class="program-wrapper">
            <h2>CPA</h2>
            <p>Фиксированная ставка за продажу</p>
          </div>
        </div>

      </div>

    </section>

    <section id="contacts" class="section">
      <h2>Наши социальные сети</h2>

      <div class="contacts-w">
        <a href="https://t.me/AveVpnInfo" target="_blank" style="text-decoration: none; color: inherit;">
          <div style="cursor: pointer;">
            <img src="/avecircle.png" alt="">
            <p>TG канал</p>
          </div>
        </a>

        <a href="https://t.me/AveSupport_Bot" target="_blank" style="text-decoration: none; color: inherit;">
          <div style="cursor: pointer;">
            <img src="https://upload.wikimedia.org/wikipedia/commons/8/82/Telegram_logo.svg" alt="">
            <p>Поддержка</p>
          </div>
        </a>
      </div>

    </section>

  </div>
</template>

<script>
export default {
  name: "WelcomePage",
  data() {
    return {
      isMenuOpen: false,
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    closeMenu() {
      this.isMenuOpen = false;
    },
    goToTelegram() {
      window.open("https://t.me/AveVpnBot?start=7684477652", "_blank");
    },
  },
};
</script>

<style scoped>
.welcome-page {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  font-family: Arial, sans-serif;
  background-color: black;
  color: #fff;
  overflow-x: hidden;
  overflow-y: auto;
  padding-top: 80px;
}

/* Navbar */
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: rgba(17, 17, 17, 0.5); /* Сделаем немного прозрачнее */
  backdrop-filter: blur(10px); /* Добавляем блюр */
  -webkit-backdrop-filter: blur(10px);
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 15px 0px;
  z-index: 10;
  box-shadow: 0 2px 4px rgb(117, 216, 185);
  flex-wrap: nowrap;
  font-size: 1.2rem;
}

.logo {
  width: 100px;
  height: auto;
}

.burger {
  display: none;
  flex-direction: column;
  cursor: pointer;
  gap: 4px;
}

.burger span {
  width: 25px;
  height: 3px;
  background-color: white;
  border-radius: 2px;
  transition: all 0.3s ease;
}

.burger.open span:nth-child(1) {
  transform: rotate(45deg) translate(5px, 5px);
}
.burger.open span:nth-child(2) {
  opacity: 0;
}
.burger.open span:nth-child(3) {
  transform: rotate(-45deg) translate(5px, -5px);
}

.navbar-menu {
  display: flex;
  gap: 25px;
  list-style: none;
  padding: 0;
  margin: 0;
}

.navbar-menu li a {
  color: white;
  text-decoration: none;
  font-size: 1.2rem;
}

.navbar-menu li a:hover {
  text-decoration: underline;
}

.navbar-right .cabinet-link {
  color: black;
  text-decoration: none;
  font-weight: bold;
  background-color: #75d8b9;
  padding: 10px;
  border-radius: 15px;
}

.program-info button:hover,
.tariff-price button:hover,
.test-info button:hover,
.cabinet-link:hover {
  background-color: #559a86;
}

.cabinet-link {
  cursor: pointer;
}

.program-info button:active,
.tariff-price button:active,
.test-info button:active {
  transform: scale(0.9);
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  width: 100%;
  padding-top: 20px;
  background-color: black;
  padding-bottom: 40px;
  min-height: 100vh;
}

.content h1 {
  width: 100%;
  font-size: 24vw;
  text-align: center;
  color: #e3e3e3;
  margin: 0;
  line-height: 1;
}

.content-info {
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: right;
  gap: 10vw;
  font-size: 2vw;
  font-weight: 600;
  max-width: 90%;
  color: #e3e3e3;
}

.content-info p {
  max-width: 32vw;
}

.test-info {
  display: flex;
  flex-direction: column;
  text-align: left;
  max-width: 25vw;
}

.program-info button,
.tariff-price button,
.test-info button {
  border: none;
  padding: 10px;
  background-color: #75d8b9;
  color: black;
  font-size: 1.2rem;
  border-radius: 10px;
  cursor: pointer;
}

h1 {
  font-size: 2.5rem;
  margin-bottom: 10px;
}

.highlight {
  color: #75d8b9;
}

.achiv-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 40px;
  flex-wrap: wrap;
}

#advantages {
  background-color: #75d8b9;
  width: 100%;
  max-width: none;
  margin: 0;
  color: black;
}

.achiv-container h3 {
  font-size: 1.5rem;
  margin-bottom: 5px;
}

.achiv-container span {
  font-size: 0.9rem;
  color: #d3d3d3;
}

.section {
  width: 100%;
  padding: 20px;
}

.section h2 {
  margin-bottom: 10px;
  font-size: 1.8rem;
}

.section p,
.section ul {
  font-size: 1rem;
  line-height: 1.6;
}

.section ul {
  padding-left: 20px;
}
.free-trial-info {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 40px;
}

.free-trial-info button {
  padding: 15px;
  border: none;
  background-color: black;
  color: #75d8b9;
  border-radius: 15px;
  font-size: 1.2rem;
  width: 30%;
  cursor: pointer;
}

.free-trial-info button:active {
  transform: scale(0.9);
}

.free-trial-info p {
  font-size: 1.5rem;
  font-weight: 600;
}

.free-trial {
  display: flex;
  flex-direction: column;
}
.free-trial p {
  margin: 0;
}
.badge {
  background-color: black;
  color: #75d8b9;
  padding: 5px;
  border-radius: 15px;
  text-align: center;
}

.link {
  color: #00aaff;
  text-decoration: none;
}

.link:hover {
  text-decoration: underline;
}

.or {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 25px 0;
}

.or span {
  padding: 0 20px;
  position: relative;
  background-color: #75d8b9;
  z-index: 2;
}

.or:after {
  content: "";
  width: 100%;
  height: 2px;
  background-color: black;
  position: absolute;
  left: 0;
  top: 2px;
  bottom: 0;
  margin: auto;
}

.old-price {
    font-size: 0.9em;
    color: #989090;
    text-decoration: line-through;
  }

.new-price {
    color: black;
    font-size: 1.2em;
  }

.tariffs-wrapper {
  display: flex;
  flex-direction: row;
  gap: 40px;
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;
}

.basic,
.medium,
.premium {
  border: 5px solid black;
  border-radius: 30px;
  background-color: white;
  padding: 10px;
}

.tariff-icon {
  position: relative;
  display: flex;
}

.tariff-icon img {
  width: 300px;
  border-radius: 20px;
  display: block;
}

.overlay-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-weight: bold;
  mix-blend-mode: overlay;
  width: 100%;
  font-size: 2.2rem;
}

.tariff-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px;
}

.tariff-info h2 {
  margin: 0 0 10px;
}

.tariff-info p {
  margin: 0;
  font-weight: 600;
}

.tariff-price {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  padding: 0 10px 10px 0;
  align-items: center;
}

.prices {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 50%;
}

.tariff-price h2{
  margin: 0;
}

.tariff-price button {
  width: 50%;
}

#tariffs {
  background-color: white;
  color: black;
}

.partners-wrapper {
  display: flex;
  flex-direction: column;
  gap: 50px;
}

.conditions-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  gap: 40px;
  margin-bottom: 20px;
}

.program-wrapper {
  display: flex;
  flex-direction: column;
  border: 1px solid #d2d2d2;
  align-items: flex-start;
  border-radius: 15px;
  padding: 15px;
  width: 210px;
}

.program-wrapper h2 {
  margin: 0;
}

.program-wrapper p {
  font-size: 1.5rem;
  margin: 0;
  color: #383838;
  text-align: left;
}

.program-info {
  font-size: 1.3rem;
  width: 400px;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.cabinet-info {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.cabinet-info img {
  width: 230px;
}

.cabinet-info-text {
  text-align: left;
}

.cabinet-info-text p {
  font-size: 1.5rem;
  margin: 0;
  color: #383838;
}

#contacts img {
  width: 100px;
}

.contacts-w {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 40px;
  margin-top: 40px;
  margin-bottom: 40px;
}

.contacts-w p {
  font-size: 1.2rem;
}

/* Адаптивность */
@media (max-width: 800px) {
  .burger {
    display: flex;
  }

  .navbar-menu {
    position: absolute;
    top: 60px;
    left: 0;
    right: 0;
    flex-direction: column;
    background-color: rgba(26, 26, 26, 0.95);
    gap: 10px;
    padding: 15px 20px;
    display: none;
  }

  .tariffs-wrapper {
    display: flex;
    flex-direction: column;
  }

  .navbar-menu.open {
    display: flex;
  }

  .navbar-right {
    display: none;
  }

  .navbar-left {
    display: flex;
    align-items: center;
  }

  .logo {
    width: 80px;
  }

  h1 {
    font-size: 2rem;
  }

  .free-trial-info {
    display: flex;
    flex-direction: row;
    gap: 30px;
    padding: 0 10px 0 10px;
  }

  .free-trial-info button {
    width: auto;
  }

  .free-trial-info p {
    margin: 0;
  }

  .achiv-container h3 {
    font-size: 1.3rem;
  }

  .achiv-container span {
    font-size: 0.8rem;
  }

  .section {
    padding: 15px;
  }

  .section h2 {
    font-size: 1.5rem;
  }

  .section p,
  .section ul {
    font-size: 0.9rem;
  }

  .content-info {
    flex-direction: column;
    align-items: center;
    gap: 10px; /* можно увеличить или уменьшить по желанию */
    text-align: left;
    font-size: 1.5rem;
  }

  .content-info p {
    max-width: 90vw;
  }

  .test-info {
    max-width: 90vw;
    text-align: right;
  }

  .cabinet-info-text p {
    font-size: 1rem;
  }

  .cabinet-info img {
    width: 140px;
  }

  .program-info {
    font-size: 1rem;
    width: 240px;
  }

  .conditions-wrapper {
    gap: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .program-wrapper {
  }

}
</style>
